export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 80 80" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
            <g id="终稿" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="web-二合一-Teaser（全）" transform="translate(-920.000000, -4034.000000)" fill="currentColor">
                    <g id="编组-4备份" transform="translate(400.000000, 3607.000000)">
                        <g id="矩形-3" transform="translate(0.000000, 152.000000)">
                            <g id="编组-2" transform="translate(520.000000, 275.000000)">
                                <circle id="椭圆形" fillOpacity="0.4" cx="40" cy="40" r="40"></circle>
                                <path
                                    d="M47.6832816,29.3665631 L58.8291796,51.6583592 C59.5701474,53.1402947 58.9694743,54.9423138 57.4875388,55.6832816 C57.0709725,55.8915647 56.6116333,56 56.145898,56 L33.854102,56 C32.1972477,56 30.854102,54.6568542 30.854102,53 C30.854102,52.5342647 30.9625372,52.0749255 31.1708204,51.6583592 L42.3167184,29.3665631 C43.0576862,27.8846277 44.8597053,27.2839546 46.3416408,28.0249224 C46.922223,28.3152135 47.3929905,28.7859809 47.6832816,29.3665631 Z"
                                    id="三角形"
                                    transform="translate(45.000000, 40.000000) rotate(-270.000000) translate(-45.000000, -40.000000) "
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export const EFVideoRectPlay = (props: { width?: number; height?: number }) => {
    return (
        <svg width={`${props.width || 29}px`} height={`${props.height || 20}px`} viewBox="0 0 29 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="终稿" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="web-二合一-Teaser" transform="translate(-880.000000, -3969.000000)" fill="#FFFFFF" fillRule="nonzero">
                    <g id="编组-4备份-3" transform="translate(400.000000, 3512.000000)">
                        <g id="矩形-3" transform="translate(0.000000, 152.000000)">
                            <g id="编组-4备份-2" transform="translate(448.000000, 285.000000)">
                                <g id="编组-2" transform="translate(32.000000, 16.000000)">
                                    <path
                                        d="M28.3947545,7.12420382 C28.0613839,5.89490446 27.0774554,4.92675159 25.8313616,4.59872611 C23.5689732,4 14.5,4 14.5,4 C14.5,4 5.43102679,4 3.16863839,4.5955414 C1.91930804,4.92356688 0.938616071,5.89171975 0.605245536,7.12101911 C0,9.35031847 0,14 0,14 C0,14 0,18.6496815 0.605245536,20.8757962 C0.938616071,22.1050955 1.92254464,23.0732484 3.16863839,23.4012739 C5.43102679,24 14.5,24 14.5,24 C14.5,24 23.5689732,24 25.8313616,23.4012739 C27.080692,23.0732484 28.0613839,22.1050955 28.3947545,20.8757962 C29,18.6496815 29,14 29,14 C29,14 29,9.35031847 28.3947545,7.12420382 Z M11.6194196,18.2675159 L11.6194196,9.73248408 L19.1283482,13.9681529 L11.6194196,18.2675159 Z"
                                        id="形状"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
